import React from "react";

const VendorNotes = () => {
  return (
    <div className="flex justify-center items-center h-full bg-gradient-to-br from-[#1F2525] to-[#1E3A8A] animate-[pulse_8s_ease-in-out_infinite]">
      <div className="relative">
        <h1
          className="text-5xl md:text-6xl font-serif font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#84708d] to-[#3B82F6] drop-shadow-[0_4px_6px_rgba(0,0,0,0.5)] animate-[bounceAndShine_2s_ease-in-out_infinite] [text-shadow:_0_0_15px_rgba(59,130,246,0.5)] hover:scale-105 hover:[text-shadow:_0_0_25px_rgba(59,130,246,0.8)] transition-all duration-300 ease-in-out"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Notes Coming Soon
        </h1>
        <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-transparent via-[#1E3A8A] to-transparent hover:bg-gradient-to-r hover:from-[#1E3A8A] hover:via-[#3B82F6] hover:to-[#1E3A8A] hover:h-1.5 transition-all duration-300 ease-in-out"></div>
      </div>
    </div>
  );
};

export default VendorNotes;
